import { LayoutWidth, NAV_HEIGHT } from './enums';
import { _primitive as primitive } from './primitives';

// NOTE: we aren't actively using these for new designs but maybe we should in the future (migrate here from direct primitive use)
export const _designTokens = {
  'background-active': primitive.$fieryRed,
  'background-badge': primitive.$bbqBrown,
  'background-button-primary-default': primitive.$fieryRed,
  'background-button-primary-hover': primitive.$fieryRedHover,
  'background-button-primary-pressed': primitive.$fieryRedPressed,
  'background-button-secondary-hover': primitive.$bbqBrownOpacity15,
  'background-button-secondary-pressed': primitive.$bbqBrownOpacity20,
  'background-checked': primitive.$bbqBrown,
  'background-default': primitive.$mayoEggWhite,
  'background-switch-track': primitive.$bbqBrown,
  'border-color-checked': primitive.$bbqBrown,
  'border-color-focus': primitive.$bbqBrown,
  'border-color-hover': primitive.$bbqBrown,
  'icon-active': primitive.$fieryRed,
  'icon-button-secondary': primitive.$bbqBrown,
  'icon-button-tertiary-default': primitive.$bbqBrown,
  'icon-default': primitive.$bbqBrown,
  'icon-reversed': primitive.$mayoEggWhite,
  'text-active': primitive.$fieryRed,
  'text-button-primary-reversed': primitive.$bbqBrown,
  'text-button-secondary': primitive.$bbqBrown,
  'text-button-tertiary-default': primitive.$bbqBrown,
  'text-button-tertiary-hover': primitive.$fieryRed,
  'text-default': primitive.$bbqBrown,
  'text-hero-light': primitive.$bbqBrown,
  'text-link-default': primitive.$bbqBrown,
  'text-link-hover': primitive.$fieryRed,
  'text-link-reversed': primitive.$mayoEggWhite,
  'text-reversed': primitive.$mayoEggWhite,
  'border-color-input': primitive.$blackOpacity30,
  'border-color-input-default': primitive.$blackOpacity30,
  'border-color-options': primitive.$blackOpacity10,
  'border-radius-input': '4px',
  'border-width-input': '1px',
  'height-input': '48px',
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default-reversed': primitive.$white,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-dialog': primitive.$white,
  'background-focus': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-button-secondary': primitive.$bbqBrown,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'icon-button-primary': primitive.$white,
  'icon-button-reversed': primitive.$white,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-default': primitive.$blackOpacity30,
  'increment-active': primitive.$bbqBrown,
  'text-button-primary': primitive.$white,
  'text-button-reversed': primitive.$white,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'pickup-timed-fire-selector-button-background': primitive.$white,
  'background-contrast-loyalty': primitive.$bbqBrown,
  'background-contrast-loyalty-reversed': primitive.$flamingOrange,
  'background-icon-header-contrast': primitive.$blackOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-menu-customization-image': primitive.$bbqBrown,
  'border-default': `1px solid ${primitive.$blackOpacity10}`,
  'icon-header-contrast': primitive.$bbqBrown,
  'text-accent-order-number': primitive.$fieryRed,
  'crown-color': primitive.$crownColor,
  'background-badge-subtle': primitive.$blackOpacity4,
  'background-button-primary-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-pressed-reversed': primitive.$whiteOpacity10,
  'background-button-secondary-hover-reversed': primitive.$whiteOpacity10,
  'background-button-secondary-pressed-reversed': primitive.$whiteOpacity10,
  'background-error': primitive.$error,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert-success': '#D1FAE5',
  'background-inline-alert-error': '#FFE7E7',
  'background-inline-alert-warning': '#FFEDD5',
  'background-inline-alert-warning-light': '#FFCFAD',
  'background-handlebar': primitive.$blackOpacity10,
  'background-hover': primitive.$blackOpacity4,
  'background-loader-indicator-reversed': primitive.$white,
  'background-skeleton-loader-start': primitive.$blackOpacity10,
  'background-skeleton-loader-end': primitive.$blackOpacity4,
  'background-toast': primitive.$black,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-reversed': primitive.$whiteOpacity10,
  'text-action-sheet-title': primitive.$blackOpacity30,
  'text-input-placeholder': '#71717A',
  'text-toast': primitive.$white,

  // alert tokens
  'alert-info-background': primitive.$flamingOrange,
  'alert-info-text': primitive.$white,
  'alert-success-background': primitive.$crunchyGreen,
  'alert-success-text': primitive.$white,
  'alert-warning-background': primitive.$fieryRed,
  'alert-warning-text': primitive.$white,
  'alert-error-background': primitive.$fieryRed,
  'alert-error-text': primitive.$white,

  // semantic color aliases
  'color-error': primitive.$error,
  'color-secondary': primitive.$fieryRed,
  'color-tertiary': primitive.$bbqBrown,
  'color-pricing': primitive.$bbqBrown,
  'color-validated': primitive.$crunchyGreen,
  'color-contrast-background': primitive.$bbqBrown,
  'background-card': primitive.$white,
  'border-color-disabled-legacy': primitive.$disabledTan,
  'color-disabled-legacy': primitive.$disabledTan,

  // typography
  'text-transform-headlines': 'none',

  // layout
  'layout-section-max-width': `${LayoutWidth.REGULAR}px`,
  'layout-smaller-section-max-width': `${LayoutWidth.SMALL}px`,
  'layout-nav-height-mobile': `${NAV_HEIGHT.MOBILE}px`,
  'layout-nav-height-desktop': '78px',
} as const;

/** Strictly-typed accessor – generic constraint enforces valid keys regardless of noImplicitAny */
export function getDesignToken<K extends keyof typeof _designTokens>(
  key: K
): typeof _designTokens[K] {
  return _designTokens[key];
}
